import React from 'react';
import PropTypes from 'prop-types';

import Button from 'common/components/Button';
import { LazyImage } from 'common/components/LazyImage';

function Landing({
  navigateToNextStep,
  content,
  mobileImageUrl,
  desktopImageUrl,
  buttonText,
}) {
  return (
    <div className="build-your-plan__landing row">
      <div className="col-xs-12 col-sm-6">
        <span dangerouslySetInnerHTML={{ __html: content }} />
        <LazyImage
          src={mobileImageUrl}
          className="build-your-plan__landing-hero-mobile"
        />
        <Button
          className="button--vivid button--full-width-mobile"
          onClick={() => navigateToNextStep()}
        >
          {buttonText}
        </Button>
      </div>
      <div className="col-xs-12 col-sm-6 build-your-plan__landing-hero-container">
        <LazyImage
          src={desktopImageUrl}
          className="build-your-plan__landing-hero-desktop"
        />
      </div>
    </div>
  );
}

Landing.propTypes = {
  navigateToNextStep: PropTypes.func.isRequired,
  content: PropTypes.string.isRequired,
  mobileImageUrl: PropTypes.string.isRequired,
  desktopImageUrl: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
};

export default Landing;
